import React from 'react';
import pt from 'prop-types';
import { MrInputRadio, MrInputRadioGroup } from '@ion/components';
import { Alert } from '@metarouter-private/mr-mui';
import { useConsentCategoriesContext } from 'app/context/consent-categories-context';
import { ConsentCategorySelect } from 'app/components/consent-categories-select/ConsentCategorySelect';
import { CONSENT_MATCH_ID_ENABLED, CONSENT_MATCH_ID_CONSENT_CODE } from 'app/components/analytics-builder/form-keys';

export default function MatchIdConsent({ formState, setField, validateField, validateRequired, resetError }) {
  const { consentCategories } = useConsentCategoriesContext();
  const hasSelectedCategory = Boolean(formState[CONSENT_MATCH_ID_CONSENT_CODE]?.value);
  const enabledValue = formState[CONSENT_MATCH_ID_ENABLED]?.value ?? (hasSelectedCategory ? 'true' : 'false');
  const hasCategories = consentCategories.length > 0;

  return (
    <div>
      <MrInputRadioGroup
        overrideValue={enabledValue}
        name={CONSENT_MATCH_ID_ENABLED}
        label="anonymousId Consent"
        helperText="Whether opting out of a consent category should also remove the visitor's ajs_anonymous_id identifier from the browser."
        onChange={setField}
        resetError={resetError}
        required
      >
        <MrInputRadio
          value="false"
          label="Disabled"
          tooltip="The ajs_anonymous_id identifier is kept regardless of consent decisions."
        />
        <MrInputRadio
          value="true"
          label="Enabled"
          tooltip="When the selected consent category is opted out, the ajs_anonymous_id identifier is removed from the browser."
        />
      </MrInputRadioGroup>
      {enabledValue === 'true' && !hasCategories && (
        <Alert severity="warning">
          Your organization has no consent categories, so anonymousId Consent cannot be configured. An Integration
          Manager or Super Admin can create them.
        </Alert>
      )}
      {enabledValue === 'true' && (
        // Reuses the shared select so this dropdown lists categories exactly
        // as every other consent-category picker on the page does; a local
        // copy formatted them as "Marketing (C0001)" while the identity-sync
        // selects immediately below showed "C0001 - Marketing".
        <ConsentCategorySelect
          label="anonymousId Consent Category"
          onChange={setField}
          value={formState[CONSENT_MATCH_ID_CONSENT_CODE]?.value ?? ''}
          onBlur={validateField}
          onFocus={resetError}
          name={CONSENT_MATCH_ID_CONSENT_CODE}
          testId="anonymousIdConsentCategory"
          errorMsg={formState[CONSENT_MATCH_ID_CONSENT_CODE]?.errorMsg}
          validators={[validateRequired()]}
          alphabetized={false}
          placeholder
          helperText="The consent category that controls the identifier — when a visitor opts out of it, ajs_anonymous_id is deleted."
          required
        />
      )}
    </div>
  );
}

MatchIdConsent.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  validateField: pt.func.isRequired,
  validateRequired: pt.func.isRequired,
  resetError: pt.func.isRequired,
};
